import {
  Box,
  useToast,
  FormControl,
  FormLabel
} from "@chakra-ui/react";
import {
  useEffect,
  useState
} from "react";
import { Select } from "chakra-react-select";
import * as _ from "lodash";

import { Text } from "src/components/text";
import { useUsersApi } from "src/api/users/users.api";
import { useAuthContext } from "src/hooks/useAuthContext";

interface AddPartipantsProps {
  onSelect: (participantId: string) => void;
  selectedPartner?: string;
}

export const AddParticipants: React.FC<AddPartipantsProps> = props => {
  const { authDataState } = useAuthContext();
  const [ listUsersRes, listUsersReq ] = useUsersApi("GET_PARTNERS");
  const [ searchedUsers, setSearchedUsers ] = useState<Array<{value: string; label: string}>>([]);
  const toast = useToast();

  useEffect(() => {
    listUsersReq({});
  }, [ listUsersReq ]);

  useEffect(() => {
    if (listUsersRes.data) {
      if (authDataState.user?._id) {
        const usersList = listUsersRes.data.results.filter(u => u._id !== authDataState.user?._id);

        // Initialise searched users
        setSearchedUsers(_.map(usersList, u => ({
          label: u.name,
          value: u._id
        })));
      }
    }

    if (listUsersRes.error) {
      toast({
        status: "error",
        title: "Could not fetch users",
        description: "Please try again"
      });
    }
  }, [
    listUsersRes,
    toast,
    authDataState
  ]);

  return (
    <Box
      m={10}
      p={5}
      bg="whitesmoke"
      borderRadius={4}
    >
      <Text as="h3">
        Session participants
      </Text>

      <Text as="p">
        Each session requires two participants
      </Text>

      <FormControl
        mt={10}
        paddingRight={5}
        margin={3}
        id="startTime"
      >
        <FormLabel>
          Search for partners
        </FormLabel>

        <Select
          name="partner"
          options={searchedUsers}
          placeholder=""
          closeMenuOnSelect
          onChange={(e: {value: string; label: string}) => props.onSelect(e.value)}
          size="md"
        />

        {listUsersRes.complete && searchedUsers.length === 0 && (
          <Box marginTop="0.5rem">
            <Text as="small">
              Nobody else is in your mission.
            </Text>
          </Box>
        )}

      </FormControl>

    </Box>
  );
};
